module.exports = __webpack_public_path__ + "static/img/preliminary-round-no8.491d48b5.png";